import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";

import useUser from "../../auth/hooks/use-user";

import { 
    form, 
    formInline, 
    checkbox, 
    btnPrimary 
} from "./auth-forms.module.scss";

const newsletterSchema = Yup.object({
    subscribeNewsletter: Yup.boolean(),
});

const NewsletterForm = () => {
    const { updateNewsletter, data } = useUser();

    return (
        <Formik
            initialValues={{ subscribeNewsletter: data?.isNewsletterSubscriber || false }}
            validationSchema={newsletterSchema}
            onSubmit={updateNewsletter}
            enableReinitialize
        >
            {(formik) => {
                return (
                    <form className={form} onSubmit={formik.handleSubmit}>
                        <label className={checkbox}>
                            <input
                                type="checkbox"
                                name="subscribeNewsletter"
                                checked={formik.values.subscribeNewsletter}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <span>Chcę dostawać newsletter Fashion Fairy</span>
                        </label>
                        <button className={btnPrimary} type="submit">
                            Zapisz wybór
                        </button>
                    </form>
                );
            }}
        </Formik>
    );
};

export default NewsletterForm;
